/**
 * Returns two-thirds of a number
 * @param {number} number
 */
function getTwoThirds(number) {
  return number * 0.66666666;
}

export default getTwoThirds;
